import { render } from "./Balance.vue?vue&type=template&id=3e85729e"
import script from "./Balance.vue?vue&type=script&lang=ts"
export * from "./Balance.vue?vue&type=script&lang=ts"
script.render = render

export default script